let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dROov")).then(() => parcelRequire('1ml2E'));